import * as React from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

const inputVariants = tv({
  base: 'border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex w-full min-w-0 rounded-md border bg-transparent px-3 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:border-0 file:bg-transparent file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
  variants: {
    size: {
      sm:      'h-7 px-2 text-xs py-0.5 file:h-5 file:text-xs',
      default: 'h-9 py-1 file:h-7 file:text-sm',
      lg:      'h-11 px-4 text-base file:h-9 file:text-base',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

function Input({
  className,
  size,
  type,
  ...props
}: React.ComponentProps<'input'> & VariantProps<typeof inputVariants>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={inputVariants({ size, class: className })}
      {...props}
    />
  );
}

export { Input, inputVariants };
